/* eslint-disable require-yield */
import { put, select } from 'redux-saga/effects';
import * as actions from '../actions/index';

import {
  apaAnalytics,
  filterMetricsEasyCheckout,
  getUrl,
  getUserData,
  LOG,
  metricsPageTitle,
  setLocalStorage,
  getLocalStorage,
  parseTitle,
  mountUserData,
  parseMediaType,
  getUserFromCookie,
  limitStringSize,
  convertListToProps,
  extractInfoFromURl,
} from '../helpers/utils';
import env from '../helpers/env';

export function* setProperties(action) {
  // @todo: check if have all properties needed
  window.metrics = { ...window.metrics, ...action.metrics };

  // save metrics properties on localstorage
  let metrics = { ...(yield select(state => state.MetricsReducer.metrics)), ...action.data };
  const isAuthenticated = yield select(state => state.UserReducer.authenticated);
  const modality = yield select(state => state.SessionReducer.modality);
  const offerId = yield select(state => state.SessionReducer.offerId);
  const price = yield select(state => state.SessionReducer.offerPrice);
  const uuid = yield select(state => state.SessionReducer.uuid);

  metrics = isAuthenticated ? metrics : { ...metrics, ...getUserData({}) };
  const email = metrics.email ? metrics.email.split('@')[0] : '';
  const hasLocalMetrics = getLocalStorage(`apa-metrics-${email}`);
  LOG('[SAGA Metrics]', 'hasLocalMetrics', hasLocalMetrics);

  // set metrics properties in local storage to recover them in case of page reaload
  if (email && !hasLocalMetrics) {
    setLocalStorage(`apa-metrics-${email}`, {
      ...filterMetricsEasyCheckout({
        ...metrics,
        modality,
        offerId,
        price,
        uuid
      })
    });
  }

  // LOG('[SAGA Metrics]', 'setProperties');
  // const metrics = action.metrics;
  // yield put(actions.setMetricsReady(true));
}

export function* canDoMetricsPush() {
  // @todo: Criar um controle de limte para espera
  LOG('[SAGA Metrics]', 'canDoMetricsPush');
  let isReady = yield select(state => state.MetricsReducer.ready);
  while (!isReady) {
    LOG('[SAGA Metrics][WHILE][NOT READY]', isReady);
    isReady = yield select(state => state.MetricsReducer.ready);
    yield false;
  }

  LOG('[SAGA Metrics][WHILE][READY]', isReady);
  yield true;
}

export function* sendPageview(action) {
  LOG('[SAGA Metrics]', 'sendPageview', action);
  let metrics = { ...(yield select(state => state.MetricsReducer.metrics)), ...action.data };
  const isAuthenticated = yield select(state => state.UserReducer.authenticated);
  const modality = yield select(state => state.SessionReducer.modality);
  const offerId = yield select(state => state.SessionReducer.offerId);
  const price = yield select(state => state.SessionReducer.offerPrice);
  const queryParams = yield select(state => state.MetricsReducer.params);
  const uuid = yield select(state => state.SessionReducer.uuid);
  const oldOfferId = yield select(state => state.SessionReducer.oldOfferId);
  const exSubscriberEmail = yield select(state => state.UserReducer.isExSubscriber);
  const userEmail = yield select(state => state.UserReducer.user.email);
  const isExSubscriber = exSubscriberEmail === userEmail;

  let urlSuffix = '';
  if (action.data) {
    urlSuffix = action.data.urlSuffix || '';
  }
  const URL = getUrl(window.location, modality, urlSuffix) + (queryParams || '');
  LOG('[SAGA Metrics]', 'URL', URL, queryParams);
  LOG('[SAGA Metrics]', 'metrics', metrics, action, modality);
  LOG('[SAGA Metrics]', 'modality', modality);
  LOG('[SAGA Metrics]', 'price', price);
  LOG('[SAGA Metrics]', 'uuid', uuid);
  metrics = isAuthenticated ? metrics : { ...metrics, ...getUserData({}) };
  // can do metrics thing?
  yield canDoMetricsPush();
  LOG('[SAGA Metrics]', 'setTimeout');
  const TITLE = metricsPageTitle(window.location.pathname);
  const email = metrics.email ? metrics.email.split('@')[0] : '';
  const localMetrics = getLocalStorage(`apa-metrics-${email}`);

  if (localMetrics) LOG('[SAGA Metrics]', 'Consuming metrics from storage', localMetrics);

  // Set metrics propertiesfrom local storage or app state
  const properties = localMetrics ? {
    ...localMetrics,
    modalidade: modality,
    'id oferta': offerId,
    preco: price,
    uuid,
    ...isExSubscriber && oldOfferId ? { 'id oferta entrada': oldOfferId } : {},
    ...isExSubscriber ? { 'tipo usuario': 'ex-assinante' } : {}
  } : {
    ...filterMetricsEasyCheckout({
      ...metrics,
      modality,
      offerId,
      oldOfferId,
      price,
      uuid
    })
  };

  apaAnalytics({
    event: 'PageViewVirtual',
    eventPageURL: URL,
    eventPageTitle: TITLE
  });
  LOG('DEBUG_KISS', 'km_record', TITLE, URL);
  apaAnalytics({
    event: 'km_record',
    km_event: parseTitle(TITLE),
    km_property: {
      ...properties,
      url: URL
    }
  });
  LOG('sendPageview Events', URL, TITLE);
}

export function* sendActionEvent(action) {
  LOG('sendActionEvent', action);

  const metrics = { ...(yield select(state => state.MetricsReducer.metrics)), ...action.data };
  const modality = yield select(state => state.SessionReducer.modality);
  const offerId = yield select(state => state.SessionReducer.offerId);
  const price = yield select(state => state.SessionReducer.offerPrice);
  const queryParams = yield select(state => state.MetricsReducer.params);
  const oldOfferId = yield select(state => state.SessionReducer.oldOfferId);
  const exSubscriberEmail = yield select(state => state.UserReducer.isExSubscriber);
  const userEmail = yield select(state => state.UserReducer.user.email);
  const isExSubscriber = exSubscriberEmail === userEmail;

  let urlSuffix = '';
  let buttonLinkAction = '';
  if (action.data) {
    urlSuffix = action.data.urlSuffix || '';
    buttonLinkAction = action.data.buttonLinkAction || '';
  }
  const URL = `${getUrl(window.location, modality, urlSuffix)}${queryParams || ''}`;
  LOG('[SAGA Metrics]', 'URL', URL, queryParams);
  const filter = !action.dontFilter;
  const email = metrics.email ? metrics.email.split('@') : '';
  const localMetrics = getLocalStorage(`apa-metrics-${email[0]}`);

  LOG('Received metrics', metrics);

  // Set metrics properties from local storage or app state
  const properties = localMetrics ? {
    ...localMetrics,
    modalidade: modality,
    'id oferta': offerId,
    preco: price,
    ...isExSubscriber && oldOfferId ? { 'id oferta entrada': oldOfferId } : {},
    ...isExSubscriber ? { 'tipo usuario': 'ex-assinante' } : {},
    ...metrics.clube ? { 'com clube': metrics.clube } : {},
    ...metrics.status ? { 'status da compra': metrics.status } : {},
    ...metrics['sale order id'] ? { 'id da compra': metrics['sale order id'] } : {}
  } : {
    ...filterMetricsEasyCheckout({
      ...metrics,
      modality,
      offerId,
      price,
      clube: metrics.clube,
      status: metrics.status,
      saleOrderId: metrics['sale order id']
    }, filter)
  };

  apaAnalytics({
    event: 'km_record',
    km_event: parseTitle(action.event),
    km_property: {
      ...properties,
      url: URL,
      ...buttonLinkAction ? { 'url de destino ': buttonLinkAction } : {},
    }
  });
}

export function* sendCustomEvent(action) {
  LOG('sendCustomEvent', action);

  const metrics = { ...(yield select(state => state.MetricsReducer.metrics)), ...action.data };
  const modality = yield select(state => state.SessionReducer.modality);
  const offerId = yield select(state => state.SessionReducer.offerId);
  const price = yield select(state => state.SessionReducer.offerPrice);
  const queryParams = yield select(state => state.MetricsReducer.params);
  const oldOfferId = yield select(state => state.SessionReducer.oldOfferId);
  const exSubscriberEmail = yield select(state => state.UserReducer.isExSubscriber);
  const userEmail = yield select(state => state.UserReducer.user.email);
  const isExSubscriber = exSubscriberEmail === userEmail;

  let urlSuffix = '';
  if (action.data) {
    urlSuffix = action.data.urlSuffix || '';
  }
  const URL = `${getUrl(window.location, modality, urlSuffix)}${queryParams || ''}`;
  LOG('[SAGA Metrics]', 'URL', URL, queryParams);
  const filter = !action.dontFilter;
  const email = metrics.email ? metrics.email.split('@') : '';
  const localMetrics = getLocalStorage(`apa-metrics-${email[0]}`);

  LOG('Received metrics', metrics);

  // Set metrics properties from local storage or app state
  const properties = localMetrics ? {
    ...localMetrics,
    modalidade: modality,
    'id oferta': offerId,
    preco: price,
    ...isExSubscriber && oldOfferId ? { 'id oferta entrada': oldOfferId } : {},
    ...isExSubscriber ? { 'tipo usuario': 'ex-assinante' } : {},
    ...metrics.clube ? { 'com clube': metrics.clube } : {},
    ...metrics.status ? { 'status da compra': metrics.status } : {},
    ...metrics['sale order id'] ? { 'id da compra': metrics['sale order id'] } : {}
  } : {
    ...filterMetricsEasyCheckout({
      ...metrics,
      modality,
      offerId,
      price,
      clube: metrics.clube,
      status: metrics.status,
      saleOrderId: metrics['sale order id']
    }, filter)
  };

  apaAnalytics({
    event: 'km_record',
    km_event: parseTitle(action.event),
    km_property: {
      ...properties,
      url: URL
    }
  });
}

export function* sendKMSet(action) {
  LOG('sendKMSet', action);

  // apaAnalytics({
  //   'event': 'km_set',
  //   'km_property': action.data || {}
  // });
}

export function* sendKMIdentify(action) {
  LOG('sendKMIdentify', action);
  apaAnalytics({
    event: 'km_identify',
    km_property: action.data || {}
  });
}


function mountOfferData(offer) {
  if (offer && offer.modality && offer.priceTo) return { modality: offer.modality, price: offer.priceTo };

  const { userInfo } = getUserFromCookie();
  if (userInfo) {
    const email = userInfo.email ? userInfo.email.split('@')[0] : '';
    const localStorageMetrics = getLocalStorage(`apa-metrics-${email}`);
    if (localStorageMetrics) {
      return {
        modality: localStorageMetrics.modalidade,
        price: localStorageMetrics.preco
      };
    }
  }

  return { modality: '', price: '' };
}

// Send GA4 metrics
export function* sendGA4Metrics({ eventName, offer }) {
  const metrics = (yield select(state => state.MetricsReducer.metrics));
  const { tipoConteudo, editoria, subeditoria, url, title, dataMetrics, produto, piano } = metrics;
  const { price } = offer && mountOfferData(offer);
  const { idMateria } = extractInfoFromURl(url);
  const modality = yield select(state => state.SessionReducer.modality);
  const offerId = yield select(state => state.SessionReducer.offerId);
  const mediaType = parseMediaType(dataMetrics || produto);
  const tags = metrics.tags ? convertListToProps(metrics.tags, 'pag_tag') : { pag_tag: 'nao se aplica' };

  let pianoData = {};
  if (piano) {
    const { experience, origin, action } = piano;
    pianoData = (origin && origin === 'piano') ? {
      experience_name_piano: experience ? experience.title : 'nao se aplica',
      experience_id_piano: experience ? experience.id : 'nao se aplica',
      action_id_piano: action ? action.actionId : 'nao se aplica',
    } : {};
  }

  const metricsGA4 = {
    event: eventName,
    price,
    ...mountUserData(),
    value: price,
    currency: 'BRL',
    midia_type: mediaType,
    plan_cart: modality,
    promo_type: modality,
    page_category: tipoConteudo,
    page_section: editoria,
    page_section_2: subeditoria,
    page_url: limitStringSize(url),
    page_title: limitStringSize(title),
    item_id: offerId || '',
    ...tags,
    article_id: idMateria || 'nao se aplica',
    ...pianoData
  };

  if (eventName === 'purchase') {
    const purchase = yield select(state => state.SessionReducer.purchase);
    metricsGA4.transaction_id = purchase.saleOrderId;

    _ain.pushConversion(eventName, {...metricsGA4, 'transaction_id': purchase.saleOrderId});
  }

  if (eventName === 'click_add_payment_info') {
    metricsGA4.type_payment = 'cartão de crédito';
    metricsGA4.id_payment = offer && offer.id;
  }

  apaAnalytics(metricsGA4);

  if (eventName === 'add_to_cart') {
    _ain.pushConversion(eventName, {...metricsGA4, 'offer': offer && mountOfferData(offer)})
  }

  LOG('DEBUG_GA4_METRICS', `| Sending ${eventName} event`, url, metricsGA4);
}

export function* resetUserMetrics(action) {
  LOG('resetUserMetrics', action);
  const modality = yield select(state => state.SessionReducer.modality);
  const offerId = yield select(state => state.SessionReducer.offerId);
  const price = yield select(state => state.SessionReducer.offerPrice);
  const queryParams = yield select(state => state.MetricsReducer.params);
  let urlSuffix = '';
  if (action.data) {
    urlSuffix = action.data.urlSuffix || '';
  }
  const URL = `${getUrl(window.location, modality, urlSuffix)}${queryParams || ''}`;

  const metrics = yield select(state => state.MetricsReducer.metrics);
  const newMetrics = { ...metrics, ...getUserData({}) };

  yield put(actions.setProperties(newMetrics));
  yield put(actions.sendKMSet(newMetrics));

  apaAnalytics({
    event: 'km_reset',
    km_property: {
      ...filterMetricsEasyCheckout({
        ...newMetrics,
        modality,
        offerId,
        price
      }, false),
      url: URL
    }
  });
}

export function* sendPurchaseMetrics(action) {
  LOG('sendTransactionEvent', action);

  const metrics = { ...(yield select(state => state.MetricsReducer.metrics)), ...action.data };
  const UUID = yield select(state => state.SessionReducer.uuid);
  const purchase = yield select(state => state.SessionReducer.purchase);
  const { saleOrderDetail, saleOrderId, offer } = purchase;

  LOG('[apaAnalytics]', saleOrderDetail, saleOrderId, offer);
  const transaction = {
    event: 'transactionComplete',
    transactionId: `${saleOrderId}`,
    transactionAffiliation: '',
    transactionTotal: saleOrderDetail.amountPaid,
    transactionTax: 0,
    transactionShipping: 0,
    transactionProducts: saleOrderDetail.subscriptions.map(subscription => ({
      sku: `${subscription.id}`,
      name: `${subscription.title} - ${offer.altId}`,
      category: `${subscription.modality}`,
      price: subscription.price,
      quantity: 1
    }))
  };
  let hasClube = false;
  saleOrderDetail.subscriptions.forEach((subs) => {
    if (subs.modality === 'CLUBE') {
      hasClube = true;
    }
  });
  // GTM EVENT EC
  apaAnalytics(transaction);
  yield put(actions.sendGA4Metrics('purchase'));

  // KISSMETRICS EVENT EC
  /* eslint-disable */
  yield put(actions.sendCustomEvent('Compra Concluída', {
    ...metrics,
    'clube': hasClube ? 'sim' : 'nao',
    'price': saleOrderDetail.amountPaid,
    'sale order id': saleOrderId,
    'status': purchase.saleReturn === 'PENDING' ? 'pendente' : 'sucesso'
  }));
  /* eslint-enable */

  // send GA event tracking error
  if (purchase.saleReturn === 'PENDING') {
    apaAnalytics({
      event: 'errorPending',
      eventActionMessage: purchase.asMessage ? purchase.asMessage : 'sem retorno do AS',
      eventLabelMessage: `${env()} - uuid: ${UUID}`,
    });
  }

  const smartoctoData = extractInfoFromURl(metrics.url);

  /* eslint-disable */
  _ain.pushConversion(
    'Subscription',
    {
      'url': smartoctoData.url,
      'postid': smartoctoData.idMateria
    }
  );
  /* eslint-enable */
}
